<template>
  <slice
    :id="block._key"
    class="slice--video text-center"
    :class="{
      container: !isFull,
      'slice--video-full': isFull,
      'slice--video-bunny': isBunny,
    }"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div
      v-if="isBunny"
      class="slice__video"
      :class="{
        'slice__video--full': isFull && !isBunny,
        'slice__video--bunny': isBunny,
        'slice__video--mobile': isMobile,
        'slice__video--autoplay': block.is_autoplay,
        // 'slice__video--has-interaction': has_interaction,
      }"
      :style="`padding-bottom: calc(100% * ${videoRatio})`"
    >
      <client-only>
        <!-- <vimeo-player
          ref="player"
          :video-id="child.video_id"
          loop
          autoplay
          :options="{ muted: true, background: true }"
          :player-width="640"
          :player-height="800"
        /> -->

        <component
          :is="sliceComponent()"
          v-if="videoId"
          v-bind="attributes"
          style="
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          "
        >
          <video-bunny
            :src="`https://iframe.mediadelivery.net/embed/199701/${videoId}?responsive=true&autoplay=false${
              block.is_autoplay ? '&loop=true&muted=true&preload=true' : ''
            }`"
            :autoplay="block.is_autoplay"
          />

          <div v-if="hasText" class="slice__video__content">
            <portable-text :blocks="block.text" class="title" />
          </div>
        </component>
      </client-only>
    </div>
    <div v-else :class="{ 'row-md justify-center': !isFull }">
      <div class="p-relative" :class="{ 'col-md-8': !isFull }">
        <portable-text v-if="hasText" :blocks="block.text" />
        <div
          v-waypoint="{
            active: true,
            callback: onWaypoint,
            options: intersectionOptions,
          }"
          class="slice__video slice__video--youtube"
          :class="{
            'mt-1 mt-md-3': !isFull && hasText,
            'slice__video--full': isFull,
          }"
        >
          <div ref="video"></div>
          <!--
            <iframe
              ref="video"
              :video-id="slice.primary.youtube_id"
              :data-src="`https://www.youtube.com/embed/${slice.primary.youtube_id}?rel=0`"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          -->
        </div>
      </div>
    </div>
  </slice>
</template>

<script>
import NuxtSSRScreenSize from 'nuxt-ssr-screen-size'

import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText'
import VideoBunny from '@/components/video/bunny'

export default {
  name: 'BlockVideo',
  components: {
    Slice,
    PortableText,
    VideoBunny,
  },
  mixins: [NuxtSSRScreenSize.NuxtSSRScreenSizeMixin],
  props: {
    block: { type: Object, required: true },
  },
  data: () => ({
    intersectionOptions: {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: [0, 1], // [0.25, 0.75] if you want a 25% offset!
    },
  }),
  computed: {
    isBunny() {
      return this.block.type === 'bunny'
    },
    isFull() {
      return this.block.is_full
    },
    isMobile() {
      return this.$vssWidth < 769
    },
    videoId() {
      if (this.isMobile && this.isBunny) {
        if (this.block.video_mobile_id) {
          return this.block.video_mobile_id
        }

        return this.block.default_video_mobile_id
      }

      if (this.block.video_id) {
        return this.block.video_id
      }

      return this.block.default_video_id
    },
    videoRatio() {
      if (this.isBunny) {
        if (this.isMobile && this.block.ratio_mobile) {
          return this.block.ratio_mobile.height / this.block.ratio_mobile.width
        }

        return this.block.ratio.height / this.block.ratio.width
      }

      if (this.isMobile) {
        return 1
      }

      return 9 / 16
    },

    isLink() {
      return this.isBunny && this.block.link
    },
    attributes() {
      if (this.isLink) {
        return {
          to: this.block.link,
        }
      }

      return []
    },
    hasText() {
      return this.block.text && this.block.text.length > 0
    },
  },
  beforeDestroy() {
    const s = document.getElementById('yt_script')
    if (s) {
      s.remove()
    }
  },
  methods: {
    sliceComponent() {
      return this.isLink ? 'nuxt-link' : 'div'
    },
    onWaypoint({ going }) {
      if (going === this.$waypointMap.GOING_IN) {
        if (this.$refs.video) {
          this.loadVideo()
        }
      }
    },
    loadVideo() {
      const tag = document.createElement('script')

      tag.src = 'https://www.youtube.com/iframe_api'
      tag.id = 'yt_script'
      tag.onload = (_) => {
        if (YT.loaded) {
          return this.initPlayer()
        }

        YT.ready((_) => {
          this.initPlayer()
        })
      }

      document.body.appendChild(tag)
    },
    initPlayer() {
      try {
        this.player = new YT.Player(this.$refs.video, {
          height: '360',
          width: '640',
          videoId: this.videoId,
        })
      } catch (e) {
        this.$logError.captureException('Error initializing player', e)
      }
    },

    // handlePlayerReady(player) {
    //   this.player = player

    //   player.getMuted((muted) => {
    //     if (!muted) {
    //       this.has_interaction = true
    //     }
    //   })
    // },

    // handleClickOnVideo() {
    //   if (this.block.is_autoplay && this.player && !this.has_interaction) {
    //     try {
    //       this.player.getPaused((paused) => {
    //         if (!paused) {
    //           this.player.getMuted((muted) => {
    //             if (muted && this.player.supports('method', 'unmute')) {
    //               this.player.unmute()

    //               this.player.getVolume((v) => {
    //                 if (v === 0) {
    //                   this.player.setVolume(100)
    //                 }
    //               })

    //               this.soundOn = true

    //               setTimeout(() => {
    //                 this.soundOn = false
    //               }, 1500)
    //             }
    //           })
    //         }
    //       })

    //       this.has_interaction = true
    //     } catch (e) {
    //       this.$logError.captureException(e)
    //     }
    //   }
    // },
  },
}
</script>

<style lang="scss">
.slice__video {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  height: 0;
  background: #dadada;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .volume-on {
    width: rem(60px);
    height: rem(60px);
    border-radius: 50%;
    background: RGB(0 0 0 / 0.5);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    .icon {
      width: rem(32px);
      height: rem(32px);
      fill: var(--tertiary-color);
    }
  }

  &--full {
    padding-bottom: 0;
    width: 100vw;
    height: 100svh;

    .blocks--gallery & {
      width: 100%;
      height: 100%;
    }
  }

  &--youtube {
    padding-bottom: calc(100% * 360 / 640);
  }

  &__content {
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(var(--spacing) * 1);
    text-align: center;

    @include mq($from: tablet) {
      bottom: calc(var(--spacing) * 4);
    }

    .title {
      font-size: var(--jumbo-font-size);
      font-family: var(--secondary-font-family);
    }
  }
}
</style>
